import React from 'react';

import { FormikCheckbox } from '~commonInfra/components/FormikCheckbox';

import { Messages } from '../../../../../codegen/Localize';
import { SettingsSection } from '../../../../components/common/SettingsSection';
import { componentRegistryEntry } from '../../SettingsComponentRegistryFunctions';
import { SiteSettingsForSiteAdminProps } from '../../site-settings/ReactSiteSettingsForSiteAdmin';

export const REMOVE_SUBSCRIPTION_AND_DDA_EMAIL_LINKS_FIELD = 'settings.subscriptionAndDDAEmailLinksEnabled';
export const NOTIFICATION_EMAIL_SETTINGS_SECTION_TEST_ID = 'notification-email-settings-section';
export const REMOVE_SUBSCRIPTION_AND_DDA_EMAIL_LINKS_CHECKBOX_TEST_ID = 'remove-subscription-and-dda-email-links-enabled';

export type NotificationEmailSettingsSectionProps = SiteSettingsForSiteAdminProps<'subscriptionAndDDAEmailLinksEnabled'>;

export function NotificationEmailSettingsSection(props: NotificationEmailSettingsSectionProps): React.ReactElement {
  return (
    <SettingsSection
      description={Messages.notificationEmailSettingsDescription()}
      title={Messages.notificationEmailSettingsTitle()}
      testId={NOTIFICATION_EMAIL_SETTINGS_SECTION_TEST_ID}>
      <FormikCheckbox
        label={Messages.removeSubscriptionAndDDAEmailLinksDescription()}
        name={REMOVE_SUBSCRIPTION_AND_DDA_EMAIL_LINKS_FIELD}
        testId={REMOVE_SUBSCRIPTION_AND_DDA_EMAIL_LINKS_CHECKBOX_TEST_ID} />
    </SettingsSection>
  );
}

export const NotificationEmailSettingsSectionSpecs = componentRegistryEntry({
  name: 'NotificationEmailSettingsSection',
  component: NotificationEmailSettingsSection
});
